var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "input-value": _vm.value.isDone,
      "hide-details": "",
      "dense": ""
    },
    on: {
      "change": function change($event) {
        return _vm.toggleIsDone();
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }